import { render, staticRenderFns } from "./ProcesarVenta.vue?vue&type=template&id=5630de4c"
import script from "./ProcesarVenta.vue?vue&type=script&lang=js"
export * from "./ProcesarVenta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports